import { o as e, c as o, a as t } from "./core.0767a1be.js";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18 18 6M6 6l12 12"
}, null, -1), s = [
  n
];
function c(a, l) {
  return e(), o("svg", r, s);
}
const i = { render: c };
export {
  i as default,
  c as render
};
//# sourceMappingURL=close.713329b8.js.map
